/**
 * The NPC whose dialogue (or shop) window is open, or null.
 *
 * InteractionContext sets it when a dialogue opens and clears it on close;
 * PredictionLoop reads it to close the dialogue when the player walks away, and
 * NPCRenderer hides that NPC's nameplate and markers while it is set. It is
 * kept on `globalThis.__activeDialogueNpcId` because e2e bots read it there
 * (tests/e2e/lib/gameplayBot.ts); go through these two functions in game code.
 */
type DialogueGlobal = { __activeDialogueNpcId?: string | null };

export function getActiveDialogueNpcId(): string | null {
  return (globalThis as DialogueGlobal).__activeDialogueNpcId ?? null;
}

export function setActiveDialogueNpcId(npcId: string | null): void {
  (globalThis as DialogueGlobal).__activeDialogueNpcId = npcId;
}
